/**
 * BreakdownBarChart — Recharts horizontal bar chart of AI spend by feature or
 * model (P3). Same a11y contract as SpendTrendChart: `role="img"` canvas plus an
 * `sr-only` data table carrying the authoritative numbers.
 */
import { type ReactElement } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { BreakdownItem } from "@/features/admin/ai-usage/api";

export function BreakdownBarChart({ items, label }: { items: BreakdownItem[]; label: string }): ReactElement {
  return (
    <figure role="img" aria-label={label} className="w-full">
      <div className="h-64 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={items} layout="vertical" margin={{ top: 8, right: 8, bottom: 8, left: 24 }}>
            <XAxis type="number" stroke="var(--g-secondary)" fontSize={12} />
            <YAxis type="category" dataKey="key" stroke="var(--g-secondary)" fontSize={12} width={140} />
            <Tooltip />
            <Bar dataKey="cost_usd" fill="var(--g-primary)" radius={4} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <table className="sr-only">
        <caption>{label}</caption>
        <thead><tr><th>key</th><th>cost_usd</th><th>share_pct</th></tr></thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.key}><td>{it.key}</td><td>{it.cost_usd}</td><td>{it.share_pct}</td></tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
}
export default BreakdownBarChart;
